import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 102,
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      padding: theme.spacing(1, 0.25),
      borderRadius: theme.shape.borderRadius,
      border: '1px solid transparent',

      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
      '&:disabled': {
        opacity: 0.5,
      },
    },

    avatar: {
      fontSize: theme.typography.pxToRem(42),
    },
    text: {
      marginTop: theme.spacing(0.75),
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.primary.default,
    },
  }),
  { name: 'PersonaMoreButton' }
);
